module.exports = __webpack_public_path__ + "img/report-icon-active.d994874a.svg";